<stream-upcoming-game-component *ngFor="let upcomingGame of (upcomingGamesStream | async)" [upcomingGameModel]="upcomingGame">
</stream-upcoming-game-component>